export default class RegisteredMacAddressBatchService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('unregisteredMacAddresses', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/UnregisteredMacAddressService.js